import BreadCrumb from "Common/BreadCrumb";
import { BasicButton } from "Common/Components";
import DeleteModal from "Common/DeleteModal";
import TableContainer from "Common/TableContainer";
import { ModalAddSpecialPermission } from "feature/specialpermissions/components/ModalAddSpecialPermission";
import { useListSpecialPermissions } from "feature/specialpermissions/hooks/useListSpecialPermissions";
import { useSpecialPermissionStore } from "feature/specialpermissions/store";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

export const SpecialPermissionsView = () => {
  const {
    specialpermissions,
    columns,
    modalDelete,
    deleteToggle,
    deleteSpecialPermission,
  } = useListSpecialPermissions();
  const { t } = useTranslation();
  const { setIsOpenModal, setItem } = useSpecialPermissionStore();
  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t("SpecialPermission.titleListPage")}
          pageTitle={t("menu.specialPermissions")}
        />
        <div className="card">
          <div className="card-body">
            <div className="flex w-full items-center justify-between flex-wrap">
              <div className="w-1/4 max-[425px]:w-full"></div>
              <div className="mt-4">
                <BasicButton
                  onClick={() => {
                    setIsOpenModal(true);
                    setItem(null);
                  }}
                  type="button"
                >
                  <div className="flex flex-row justify-center items-center">
                    <Plus size={16} color="#fff" />
                    <span className="ml-2 text-slate-50">
                      {t("createEmploye.addNewEmployeBtn")}
                    </span>
                  </div>
                </BasicButton>
              </div>
            </div>
            <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns || []}
                data={specialpermissions || []}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>
            <ModalAddSpecialPermission />
            <DeleteModal
              show={modalDelete}
              onHide={deleteToggle}
              onDelete={deleteSpecialPermission}
            />
          </div>
        </div>
      </div>
    </>
  );
};
